import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { getSessionQueryOptions } from '@/lib/session'
import { commonSearchSchema } from '@/lib/utils'
import { identifyUser } from '@/telemetry/posthog'

// Account and approval pages require a registered account; anonymous guests must sign in.
export const Route = createFileRoute('/_auth')({
  component: Outlet,
  validateSearch: commonSearchSchema,
  beforeLoad: async ({ context }) => {
    const { data } = await context.queryClient.fetchQuery(getSessionQueryOptions())

    if (!data?.user || data.user.isAnonymous) {
      throw redirect({ to: '/login' })
    }
    identifyUser(data.user.id)
  },
  pendingComponent: () => <div>Loading…</div>,
})
